"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const _1 = require(".");
const config_1 = require("../../../../web/firebase/config");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const scale_1 = require("../../../utils/scale");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const TabTimeline = (props) => {
    const { isActive, userId, isPublicOnly, isMyProfile } = props;
    const [timeline, setTimeline] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [isLoadMore, setLoadMore] = (0, react_1.useState)(false);
    const [lastDoc, setLastDoc] = (0, react_1.useState)();
    const refIsNoMore = (0, react_1.useRef)(false);
    const firestoreSubscribe = (0, react_1.useRef)();
    const refIsActive = (0, react_1.useRef)(isActive);
    const refTimeline = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        if (isLoadMore) {
            handleGetTweet();
        }
    }, [isLoadMore]);
    (0, react_1.useEffect)(() => {
        refTimeline.current = [...timeline];
    }, [timeline]);
    (0, react_1.useEffect)(() => {
        refIsActive.current = isActive;
    }, [isActive]);
    (0, react_1.useEffect)(() => {
        handleGetTweet();
        const listener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.PROFILE_REACHED_END, () => {
            if (!refIsNoMore.current && refIsActive.current) {
                setLoadMore(true);
            }
        });
        return () => listener.remove();
    }, []);
    const handleGetTweet = () => {
        // firestoreSubscribe.current?.()
        if (!!lastDoc) {
            firestoreSubscribe.current = config_1.firebase.firestore()
                .collection('tweets')
                .where('userId', '==', userId)
                .where('publicationRange', 'in', isPublicOnly ? [0] : [0, 1])
                .where('isDeleted', '==', 0)
                .orderBy('createdAt', 'desc')
                .startAfter(lastDoc)
                .limit(8)
                .onSnapshot((querySnapshot) => {
                const startIndex = timeline.findIndex(it => it._id == lastDoc?.id);
                if (startIndex == -1)
                    return;
                const data = [];
                const documents = querySnapshot.docs;
                querySnapshot.forEach((doc) => {
                    data.push({ ...doc.data(), _id: doc.id });
                });
                setLoading(false);
                setLoadMore(false);
                if (documents.length == 0) {
                    refIsNoMore.current = true;
                    return;
                }
                ;
                const newTimeline = [...refTimeline.current];
                newTimeline.splice(startIndex + 1, data.length, ...data);
                setTimeline(newTimeline);
                setLastDoc(documents[documents.length - 1]);
            });
        }
        else {
            firestoreSubscribe.current = config_1.firebase.firestore()
                .collection('tweets')
                .where('userId', '==', userId)
                .where('publicationRange', 'in', isPublicOnly ? [0] : [0, 1])
                .where('isDeleted', '==', 0)
                .orderBy('createdAt', 'desc')
                .limit(8)
                .onSnapshot((querySnapshot) => {
                const data = [];
                const documents = querySnapshot.docs;
                querySnapshot.forEach((doc) => {
                    data.push({ ...doc.data(), _id: doc.id });
                });
                setLoading(false);
                setLoadMore(false);
                if (documents.length == 0) {
                    refIsNoMore.current = true;
                    return;
                }
                ;
                const newTimeline = [...refTimeline.current];
                newTimeline.splice(0, data.length, ...data);
                setTimeline(newTimeline);
                setLastDoc(documents[documents.length - 1]);
            });
        }
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, !isActive && { display: 'none' }] },
        timeline.map((item) => (react_1.default.createElement(_1.TimelineItem, { key: item?._id, data: item, userId: userId, isMyProfile: isMyProfile }))),
        !isLoading && timeline.length == 0 && isMyProfile && (react_1.default.createElement(react_native_1.View, { style: styles.box },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.boxTitle }, "\u65B0\u3057\u3044\u51FA\u4F1A\u3044\u304C\u5F85\u3063\u3066\u3044\u307E\u3059\uFF01"),
            react_1.default.createElement(CustomText_1.default, { style: styles.boxDescription }, `このページでは、あなたのタイムラインに対する活動履歴を確認できます。\n自分の体験や思いをシェアすることで\n他のユーザーとのつながりが広がります。\nあなたのストーリーを伝えて、交流を深めましょう。`),
            react_1.default.createElement(components_1.LinearButton, { fontWeight: "600", title: "\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u306B\u6295\u7A3F", style: styles.linearButton, containerStyle: {
                    marginTop: (0, scale_1.scale)(24),
                }, textStyle: styles.linearButtonText, onPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_POST, { data: null, type: 'POST' });
                } }))),
        !isLoading && timeline.length == 0 && !isMyProfile && (react_1.default.createElement(react_native_1.View, { style: styles.box },
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(16),
                    lineHeight: (0, scale_1.moderateScale)(24),
                    textAlign: 'center',
                    color: '#292A33',
                    paddingHorizontal: (0, scale_1.scale)(15),
                } }, "\u307E\u3060\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u306B\u5BFE\u3059\u308B\u5C65\u6B74\u304C\u3042\u308A\u307E\u305B\u3093\u3002"))),
        (isLoading || isLoadMore) && react_1.default.createElement(_1.TabBarLoading, null)));
};
exports.default = TabTimeline;
const styles = react_native_1.StyleSheet.create({
    container: {
        marginBottom: (0, scale_1.scale)(32)
    },
    box: {
        marginTop: (0, scale_1.scale)(24),
        width: '100%',
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    boxTitle: {
        width: '100%',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#292A33',
        textAlign: 'center'
    },
    boxDescription: {
        width: '100%',
        marginTop: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
        textAlign: 'center'
    },
    linearButton: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        borderRadius: (0, scale_1.scale)(4),
        justifyContent: 'center',
        alignItems: 'center'
    },
    linearButtonText: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE',
    }
});
